import { style } from "typestyle";

export const mapAndControlsContainerCN = style({
  position: "relative",
  zIndex: 1,
  width: "100%",
  minHeight: "16px",
  height: "560px",
});

export const mapAndControlsContainerCollapsedCN = style({
  height: "104px",
  minHeight: "104px",
});

export const mapContainerCN = style({
  position: "absolute",
  top: "0",
  bottom: "0",
  left: "0",
  right: "0",
  zIndex: 1,
});
